import { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& > svg': {
      width: '1rem',
      height: '1rem',
    },
  },
});

export interface ListItemIconProps {
  children: ReactNode;
  className?: string;
}

export const ListItemIcon = ({ children, className }: ListItemIconProps) => {
  const classes = useStyles();

  return <div className={classNames(classes.root, className)}>{children}</div>;
};

ListItemIcon.displayName = 'ListItem.Icon';
